var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-footer"},[(_vm.siteConfig)?_c('span',[_vm._v(_vm._s(_vm.siteConfig.webcopyright))]):_vm._e(),_vm._v("  "),_c('span',[_vm._v(_vm._s(_vm.siteConfig.webname))])])}
var staticRenderFns = []

export { render, staticRenderFns }